export function RoutedThroughMessengerMessage(): JSX.Element {
  return <>Message</>;
}
